<template>
  <v-container class="field-survey">
    <!-- Survey Method Dialog -->
    <v-dialog
      v-if="surveyMethodDialog"
      v-model="surveyMethodDialog"
      content-class="survey-method-dialog"
    >
      <v-card>
        <v-row class="mt-0">
          <v-col cols="8" offset="2" class="px-0 mt-0 py-0">
            <v-card-title tag="p" class="survey-method-dialog-title text-break justify-center mb-0 text-center px-0">
              Método de relevamiento en campo
            </v-card-title>
          </v-col>
          <v-col cols="2" class="px-2 text-end">
            <v-btn icon @click="surveyMethodDialog = false">
              <v-icon color="#00202F">close</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-card-text>
          <p>
            El relevamiento se realiza por medio de una aplicación (desarrollada por PONCE), donde el técnico recorre el equipo
            relevando la marca, modelo y estado de cada uno de los componentes.
            <br />
            <br />
            Cada bajante queda entonces numerada y se establece así un registro dónde se detalla si el equipo cuenta con regulador de
            presión, el modelo del aspersor, el tamaño de boquilla, el modelo de difusor y varios parámetros adicionales.
          </p>
          <v-img :src="require('../../assets/audits/surveyMethod.png')" max-width="315px" class="mt-5"/>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Comments Dialog -->
    <v-dialog
      v-if="commentsDialog"
      v-model="commentsDialog"
      content-class="comments-dialog"
    >
      <v-card>
        <v-card-text class="py-3">
            {{ comments }}
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row class="mt-3">
      <v-col>
        <p class="field-survey-title mb-0">Detalle de relevamiento</p>
        <a class="field-survey-subtitle mb-0" @click="surveyMethodDialog = true">Método de relevamiento</a>
      </v-col>
      <v-col align="end" style="align-content: center;">
        <v-icon class="d-inline icon-center" color="#00202F" size="1rem">date_range</v-icon>
        <p class="mb-0 d-inline">{{parseDate(auditData.workDate)}}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-container fluid class="Content d-flex pa-0">
        <div class="Options overflow-hidden pr-1 mr-3">
          <v-radio-group v-model="selectedOption" mandatory class="px-4 pt-0">
            <v-radio
              v-for="option in options"
              :key="option"
              :label="option"
              :value="option"
              color="#0098E1"
              :style="{'font-weight': selectedOption === option ? '600' : '400'}"
            />
          </v-radio-group>
        </div>
        <div class="Graphic fill-height align-center justify-left">
          <template v-if="selectedOption === 'Recomendaciones'">
            <div style="height: 100%; place-content: center;" v-if="checkObservationsDocumentEmpty()" >
              <p class="text-center mb-0">No hay recomendaciones</p>
            </div>
            <KeystoneDocumentRenderer v-else :document="auditData.observations.document" />
          </template>
          <template v-else-if="selectedOption === 'Bajantes a revisar'">
            <v-row class="mt-0">
              <v-col offset="1" align="left" class="px-0">
                <p class="survey-text-label mb-0"><strong>{{outletsConfigurationAnalysis.total - outletsConfigurationAnalysis.correct}}</strong> de {{outletsConfigurationAnalysis.total}} bajantes a revisar</p>
              </v-col>
            </v-row>

            <v-row class="mt-0">
              <v-col cols="1" class="px-2 pb-0 text-end">
                <v-icon class="icon-center" v-if="outletsConfigurationAnalysis.outletsWithoutRegulator.length > 0" size="1rem" color="#F93A2F">report</v-icon>
                <v-icon class="icon-center" v-else size="1rem" color="#52B847">check_circle</v-icon>
              </v-col>
              <v-col class="pl-0 pb-0">
                <v-row>
                  <p class="survey-text-body-label text-left mb-0">Cantidad de aspersores sin regulador:</p>
                  <p class="survey-text-body text-left mb-0 ml-1">{{outletsConfigurationAnalysis.outletsWithoutRegulator.length}}</p>
                </v-row>
                <v-row class="mt-0">
                  <v-chip small v-for="(outlet, outletIndex) in outletsConfigurationAnalysis.outletsWithoutRegulator" class="mr-2 my-1" :key="outletIndex" label>Bajante {{outlet.outletNumber}} (Tramo {{outlet.spanNumber}})</v-chip>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col cols="1" class="px-2 pb-0 text-end">
                <v-icon class="icon-center" v-if="Object.keys(outletsReportData.regulatorModels).length > 1" size="1rem" color="#F8C300">mdi-alert</v-icon>
                <v-icon class="icon-center" v-else size="1rem" color="#52B847">check_circle</v-icon>
              </v-col>
              <v-col class="pl-0 pb-0">
                <v-row>
                  <p class="survey-text-body-label text-left mb-0">Modelos de reguladores:</p>
                  <p class="survey-text-body text-left mb-0 ml-1">{{Object.keys(outletsReportData.regulatorModels).length}}</p>
                </v-row>
                <v-row>
                  <v-chip class="mr-2 my-1" small label v-for="regulatorModel in Object.keys(outletsReportData.regulatorModels)" :key="regulatorModel">{{regulatorModel}} ({{outletsReportData.regulatorModels[regulatorModel]}} {{outletsReportData.regulatorModels[regulatorModel] === 1 ? 'bajante' : 'bajantes'}})</v-chip>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col cols="1" class="px-2 pb-0 text-end">
                <v-icon class="icon-center" v-if="Object.keys(outletsReportData.sprinklerModels).length > 1" size="1rem" color="#F8C300">mdi-alert</v-icon>
                <v-icon class="icon-center" v-else size="1rem" color="#52B847">check_circle</v-icon>
              </v-col>
              <v-col class="pl-0 pb-0">
                <v-row>
                  <p class="survey-text-body-label text-left mb-0">Cantidad de modelos de aspersor:</p>
                  <p class="survey-text-body text-left mb-0 ml-1">{{Object.keys(outletsReportData.sprinklerModels).length}}</p>
                </v-row>
                <v-row>
                  <v-chip class="mr-2 my-1" small label v-for="sprinklerModel in Object.keys(outletsReportData.sprinklerModels)" :key="sprinklerModel">{{sprinklerModel}} ({{outletsReportData.sprinklerModels[sprinklerModel]}} {{outletsReportData.sprinklerModels[sprinklerModel] === 1 ? 'bajante' : 'bajantes'}})</v-chip>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col cols="1" class="px-2 pb-0 text-end">
                <v-icon class="icon-center" v-if="outletsConfigurationAnalysis.sprinklersWithoutNozzle.length > 0" size="1rem" color="#F93A2F">report</v-icon>
                <v-icon class="icon-center" v-else size="1rem" color="#52B847">check_circle</v-icon>
              </v-col>
              <v-col class="pl-0 pb-0">
                <v-row>
                  <p class="survey-text-body-label text-left mb-0">Cantidad de aspersores sin boquilla:</p>
                  <p class="survey-text-body text-left mb-0 ml-1">{{ outletsConfigurationAnalysis.sprinklersWithoutNozzle.length }}</p>
                </v-row>
                <v-row>
                  <v-chip class="mr-2 my-1" small label v-for="(sprinkler, sprinklerIndex) in outletsConfigurationAnalysis.sprinklersWithoutNozzle" :key="sprinklerIndex">Bajante {{sprinkler.outletNumber}} (Tramo {{sprinkler.spanNumber}})</v-chip>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col cols="1" class="px-2 pb-0 text-end">
                <v-icon class="icon-center" v-if="outletsConfigurationAnalysis.sprinklersWithoutPad.length > 0" size="1rem" color="#F93A2F">report</v-icon>
                <v-icon class="icon-center" v-else size="1rem" color="#52B847">check_circle</v-icon>
              </v-col>
              <v-col class="pl-0 pb-0">
                <v-row>
                  <p class="survey-text-body-label text-left mb-0">Cantidad de aspersores sin deflector:</p>
                  <p class="survey-text-body text-left mb-0 ml-1">{{outletsConfigurationAnalysis.sprinklersWithoutPad.length}}</p>
                </v-row>
                <v-row>
                  <v-chip class="mr-2 my-1" small label v-for="(sprinkler, sprinklerIndex) in outletsConfigurationAnalysis.sprinklersWithoutPad" :key="sprinklerIndex">Bajante {{sprinkler.outletNumber}} (Tramo {{sprinkler.spanNumber}})</v-chip>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col cols="1" class="px-2 pb-0 text-end">
                <v-icon class="icon-center" v-if="Object.keys(outletsReportData.padModels).length > 1" size="1rem" color="#F8C300">mdi-alert</v-icon>
                <v-icon class="icon-center" v-else size="1rem" color="#52B847">check_circle</v-icon>
              </v-col>
              <v-col class="pl-0 pb-0">
                <v-row>
                  <p class="survey-text-body-label text-left mb-0">Modelos de deflectores:</p>
                  <p class="survey-text-body text-left mb-0 ml-1">{{Object.keys(outletsReportData.padModels).length}}</p>
                </v-row>
                <v-row>
                  <v-chip class="mr-2 my-1" small label v-for="padModel in Object.keys(outletsReportData.padModels)" :key="padModel">{{padModel}} ({{outletsReportData.padModels[padModel]}} {{outletsReportData.padModels[padModel] === 1 ? 'bajante' : 'bajantes'}})</v-chip>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col cols="1" class="px-2 pb-0 text-end">
                <v-icon class="icon-center" v-if="outletsReportData.outletsWithoutWeight.length > 0" size="1rem" color="#F8C300">mdi-alert</v-icon>
                <v-icon class="icon-center" v-else size="1rem" color="#52B847">check_circle</v-icon>
              </v-col>
              <v-col class="pl-0 pb-0">
                <v-row>
                  <p class="survey-text-body-label text-left mb-0">Porcentaje de bajantes sin peso:</p>
                  <p class="survey-text-body text-left mb-0 ml-1">{{outletsReportData.allOutletsCount > 0 ? formatNumber((outletsReportData.outletsWithoutWeight.length * 100) / outletsReportData.allOutletsCount) : 0}}%</p>
                </v-row>
                <v-row>
                  <v-chip class="mr-2 my-1" small label v-for="(outlet, outletIndex) in outletsReportData.outletsWithoutWeight" :key="outletIndex">Bajante {{outlet.outletNumber}} (Tramo {{outlet.spanNumber}})</v-chip>
                </v-row>
              </v-col>
            </v-row>
          </template>
          <template v-else-if="selectedOption === 'Equipo'">
            <v-row class="mt-0">
              <!-- Equipo -->
              <v-col>
                <v-row>
                  <v-icon size="1.38rem" color="#00202F">mdi-sprinkler-fire</v-icon>
                  <p class="mb-0 ml-2" style="font-size: 1.13rem; font-weight: 600;">Equipo</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Tipo de equipo:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">Pivot</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Marca:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{auditData.brand || '-'}}</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Modelo:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{auditData.model || '-'}}</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Alimentación:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{auditData.powerSource ? auditData.powerSource.name : '-'}}</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Móvil:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{auditData.device.isMobile ? 'Si' : 'No'}}</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Cañón:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{auditData.endSystems.some(system => system && system.outletType && system.outletType.id === CANNON_OUTLET_TYPE_ID) ? 'Si' : 'No'}}</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Tablero:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{auditData.panelBrand || auditData.panelModel ? `${auditData.panelBrand ? `${auditData.panelBrand} ` : ''}${auditData.panelModel}` : '-'}}</p>
                </v-row>
              </v-col>

              <!-- Accesorios -->
              <v-col>
                <v-row>
                  <v-icon size="1.38rem" color="#00202F">mdi-pipe-valve</v-icon>
                  <p class="mb-0 ml-2" style="font-size: 1.13rem; font-weight: 600;">Accesorios</p>
                </v-row>
                <div class="text-left my-3">
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400; display: inline;">Reguladores:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300; display: inline;">{{Object.keys(outletsReportData.regulatorModels).length > 0 ? Object.keys(outletsReportData.regulatorModels).join(', ') : '-'}}</p>
                </div>
                <div class="text-left my-3">
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400; display: inline;">Aspersores:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300; display: inline;">{{Object.keys(outletsReportData.sprinklerModels).length > 0 ? Object.keys(outletsReportData.sprinklerModels).join(', ') : '-'}}</p>
                </div>
                <div class="text-left my-3">
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400; display: inline;">Tipos de cubierta:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300; display: inline;">{{outletsReportData.tyreSizes.length > 0 ? outletsReportData.tyreSizes.join(', ') : '-'}}</p>
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-3">
              <!-- Caudal -->
              <v-col>
                <v-row>
                  <v-icon size="1.38rem" color="#00202F">mdi-gauge</v-icon>
                  <p class="mb-0 ml-2" style="font-size: 1.13rem; font-weight: 600;">Caudal</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Caudal total teórico:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{auditData.calculatedData ? `${formatNumber(auditData.calculatedData.totalFlow)} m3/h` : '-'}}</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Capacidad de Riego Teórica:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{auditData.calculatedData ? `${formatNumber(auditData.calculatedData.irrigationCapacity)} mm` : '-'}}</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Horas de riego con márgen:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{auditData.calculatedData ? `${formatNumber(auditData.calculatedData.irrigationHoursWithMargin)} hs` : '-'}}</p>
                </v-row>
              </v-col>

              <!-- Dimensiones -->
              <v-col>
                <v-row>
                  <v-icon size="1.38rem" color="#00202F">mdi-arrow-expand-horizontal</v-icon>
                  <p class="mb-0 ml-2" style="font-size: 1.13rem; font-weight: 600;">Dimensiones</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Longitud total de riego teórica:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{formatNumber(outletsReportData.theoreticalIrrigationTotalLength)}} m</p>
                </v-row>
                <v-row>
                  <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Superficie de riego teórica:</p>
                  <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{auditData.calculatedData ? `${formatNumber(auditData.calculatedData.totalIrrigationArea)} ha` : '-'}} </p>
                </v-row>
              </v-col>
            </v-row>
            <!-- End of System -->
            <v-row class="mt-3" v-if="outletsReportData.endsOfSystemData && outletsReportData.endsOfSystemData.length > 0">
              <v-col>
                <v-row>
                  <v-icon size="1.38rem" color="#00202F">mdi-weather-windy</v-icon>
                  <p class="mb-0 ml-2" style="font-size: 1.13rem; font-weight: 600;">Final de sistema</p>
                </v-row>
                <v-row>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Modelo</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Aspersor</p>
                  </v-col>
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Presión</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Caudal (m3/h)</p>
                  </v-col>
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Radio</p>
                  </v-col>
                  <v-col cols="4" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Comentarios</p>
                  </v-col>
                </v-row>
                <v-row class="mt-1" v-for="(endOfSystem, endOfSystemIndex) in outletsReportData.endsOfSystemData" :key="endOfSystemIndex">
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{endOfSystem.sprinklerType && endOfSystem.sprinklerType.model ? endOfSystem.sprinklerType.model : '-'}}</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{endOfSystem.sprinklerType && endOfSystem.sprinklerType.brand ? endOfSystem.sprinklerType.brand : '-'}}-{{endOfSystem.sprinklerType && endOfSystem.sprinklerType.model ? endOfSystem.sprinklerType.model : '-'}}{{endOfSystem.nozzle && endOfSystem.nozzle.size ? `-${endOfSystem.nozzle.size}` : ''}}</p>
                  </v-col>
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{endOfSystem.endPressure ? formatNumber(endOfSystem.endPressure) : '-' }} psi</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{formatNumber(endOfSystem.flow, 2)}}</p>
                  </v-col>
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{formatNumber(endOfSystem.radius)}} m</p>
                  </v-col>
                  <v-col cols="4" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{endOfSystem.observations ? endOfSystem.observations : '-'}}</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- Tramos -->
            <v-row class="mt-3" v-if="auditData.spans && auditData.spans.length > 0">
              <v-col>
                <v-row>
                  <v-icon size="1.38rem" color="#00202F">mdi-transit-connection-horizontal</v-icon>
                  <p class="mb-0 ml-2" style="font-size: 1.13rem; font-weight: 600;">Tramos</p>
                </v-row>
                <v-row>
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Tramo</p>
                  </v-col>
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Caños</p>
                  </v-col>
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Caudal (m3/h)</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Largo tramo / acumulado (m)</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Motorreductor</p>
                  </v-col>
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Cubiertas</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Bajantes instaladas / totales</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Comentarios</p>
                  </v-col>
                </v-row>
                <v-row class="mt-1" v-for="(span, spanIndex) in sortedSpans" :key="spanIndex">
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{span.spanType ? span.spanType.id === SPAN_TYPE_SPAN_ID ? `Tramo ${span.number}` : span.spanType.name : '-'}}</p>
                  </v-col>
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{span.pipeAmount}} x {{span.pipe ? span.pipe.diameter : '-' }}</p>
                  </v-col>
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{ span.calculatedData && span.calculatedData.currentFlow ? formatNumber(span.calculatedData.currentFlow, 2) : '-' }}</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{ formatNumber(span.length) }} / {{ span.calculatedData && span.calculatedData.accLarge ? formatNumber(span.calculatedData.accLarge) : '-' }}</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{ span.tower && span.tower.motor && span.tower.motor.rpm ? ![OTHER_MOTOR_RPM_ID, NO_VISIBLE_MOTOR_RPM_NAME].includes(span.tower.motor.rpm.id) ? `${span.tower.motor.rpm.name} RPM` : span.tower.motor.rpm.id === OTHER_MOTOR_RPM_ID ? 'Otro' : span.tower.motor.rpm.name : '-' }}</p>
                  </v-col>
                  <v-col cols="1" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{ getUniqueTyreSizes(span.tower && span.tower.tyres) }}</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{span.outlets && span.outlets.filter(outlet => outlet && outlet.type && outlet.type.id === OUTLET_TYPE_OUTLET_ID).length}}/{{ span.outlets && span.outlets.length }}</p>
                  </v-col>
                  <v-col cols="2" class="px-1 py-0">
                    <v-icon @click="openCommentsDialog(span.observations)" style="font-size: 1.2rem; font-weight: 400; color: #00202F">mdi-comment-text-outline</v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
          <template v-else-if="selectedOption === 'Altimetría'">
            <v-row>
              <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Centro de lote:</p>
              <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{ auditData.device && auditData.device.locationLatitude && auditData.device.locationLongitude ? `${auditData.device.locationLatitude}, ${auditData.device.locationLongitude}` : '-' }}</p>
              <v-icon v-if="auditData.device && auditData.device.locationLatitude && auditData.device.locationLongitude" @click="goToLocation(auditData.device.locationLatitude, auditData.device.locationLongitude)" class="ml-1 mr-3" size="1.38rem" color="#0099E1" style="cursor: pointer">mdi-map-marker</v-icon>
              <p class="mb-0 ml-5" style="font-size: 1rem; font-weight: 400;">Altimetría de centro:</p>
              <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{elevationReference ? `${formatNumber(elevationReference.centerElevation)} m` : '-'}}</p>
            </v-row>
            <v-row class="mt-5">
              <v-icon class="mr-2" size="1.38rem" color="#F93A2F">mdi-arrow-expand-up</v-icon>
              <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Altimetría máxima:</p>
              <p class="mb-0 ml-1 mr-3" style="font-size: 1rem; font-weight: 300;">{{ elevationReference ?
                formatNumber(elevationReference.max) : ''}} m</p>
              <p class="mb-0 ml-5" style="font-size: 1rem; font-weight: 400;">Ángulo:</p>
              <p class="mb-0 ml-1 mr-3" style="font-size: 1rem; font-weight: 300;">{{elevationReference ? formatNumber(elevationReference.maxAngle) : ''}}°</p>
              <p class="mb-0 ml-5" style="font-size: 1rem; font-weight: 400;">Cota máxima:</p>
              <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{elevationReference ? formatNumber(elevationReference.max - elevationReference.centerElevation) : ''}} m</p>
            </v-row>
            <v-row class="mt-5">
              <v-icon class="mr-2" size="1.38rem" color="#00D166">mdi-arrow-collapse-down</v-icon>
              <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Altimetría mínima:</p>
              <p class="mb-0 ml-1 mr-3" style="font-size: 1rem; font-weight: 300;">{{ elevationReference ?
                formatNumber(elevationReference.min) : ''}} m</p>
              <p class="mb-0 ml-5" style="font-size: 1rem; font-weight: 400;">Ángulo:</p>
              <p class="mb-0 ml-1 mr-3" style="font-size: 1rem; font-weight: 300;">{{elevationReference ? formatNumber(elevationReference.minAngle) : ''}}°</p>
              <p class="mb-0 ml-5" style="font-size: 1rem; font-weight: 400;">Cota mínima:</p>
              <p class="mb-0 ml-1" style="font-size: 1rem; font-weight: 300;">{{elevationReference ? formatNumber(elevationReference.centerElevation - elevationReference.min) : ''}} m</p>
            </v-row>
            <v-row class="mt-5">
              <v-col cols="12" md="4" class="px-1">
                <div class="GraphicImage MapGraphicImage">
                  <div class="GraphicImageContent MapGraphicImageContent">
                    <CardSatelliteImage
                      :hasHeatmap="true"
                      :position="{ latitude: auditData.device && auditData.device.locationLatitude && auditData.device.locationLongitude ? parseFloat(auditData.device.locationLatitude) : 0, longitude: auditData.device && auditData.device.locationLatitude && auditData.device.locationLongitude ? parseFloat(auditData.device.locationLongitude) : 0 }"
                      :zoom="getPivotZoomHandler(outletsReportData.theoreticalIrrigationTotalLength)"
                      :equipLength="outletsReportData.theoreticalIrrigationTotalLength"
                      :heatmapData.sync="heatmapData"
                      :elevationReference.sync="elevationReference"
                      :addTransparentLayer="false"
                      :isAuditPivot="true"
                      :mapInstanceId="auditData.device.id"
                    />
                    <p class="AngleLabel Top">
                      <span>{{ $t("CardCircularGraphics.north") }}</span><br /><span>0°</span>
                    </p>
                    <p class="AngleLabel Right">90°</p>
                    <p class="AngleLabel Bottom">180°</p>
                    <p class="AngleLabel Left">270°</p>
                  </div>
                </div>
                <div class="ExtraInfo d-flex pl-3">
                  <div
                    v-if="elevationReference"
                    class="AltimetryReference d-flex mb-0"
                  >
                    <div class="ColorReference ml-1"></div>
                    <v-layout column class="ElevationValues">
                      <p class="ma-0 ml-2 subheading text-left">{{formatNumber(elevationReference.max)}} m</p>
                      <v-spacer />
                      <p class="ma-0 ml-2 subheading text-left">{{formatNumber(elevationReference.min)}} m</p>
                    </v-layout>
                  </div>
                </div>
              </v-col>
              <v-col class="px-1">
                <div class="GraphicImage">
                  <div class="GraphicImageContent">
                    <apexchart ref="altimetryLineChart" class="linear-altimetry" width="100%" height="300" type="line"
                      :options="altimetryLineChart.options" :series="altimetryLineChart.values" />
                    <p class="text-center mb-0" style="font-weight: 400; font-size: 14px;">Distancia al centro (m)</p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </template>
          <template v-else-if="selectedOption === 'Uniformidad'">
            <v-row class="mt-5">
              <div class="GraphicImage">
                <div class="GraphicImageContent">
                  <apexchart ref="uniformityLineChart" class="linear-uniformity" width="100%" height="300" type="line"
                    :options="uniformityLineChart.options" :series="uniformityLineChart.values" />
                    <p class="text-center mb-0" style="font-weight: 400; font-size: 14px;">Bajante</p>
                  </div>
              </div>
            </v-row>
            <!-- Table headers -->
            <v-row>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Tramo</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Largo acumulado (m)</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Área cubierta (has)</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Caudal requerido (m3/h)</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Caudal actual (m3/h)</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 400;">% Desvío</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Diferencia (m3/h)</p>
              </v-col>
            </v-row>
            <!-- Table content -->
            <v-row class="mt-1" v-for="(span, spanIndex) in sortedSpans" :key="spanIndex">
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{span.spanType ? span.spanType.id === SPAN_TYPE_SPAN_ID ? `Tramo ${span.number}` : span.spanType.name : '-'}}</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{span.calculatedData && span.calculatedData.accLarge ? formatNumber(span.calculatedData.accLarge, 2) : '-'}}</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{span.calculatedData && span.calculatedData.sectorArea ? formatNumber(span.calculatedData.sectorArea, 2) : '-'}}</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{span.calculatedData && span.calculatedData.requiredFlow ? formatNumber(span.calculatedData.requiredFlow, 2) : '-'}}</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{span.calculatedData && span.calculatedData.currentFlow ? formatNumber(span.calculatedData.currentFlow, 2) : '-'}}</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{span.calculatedData && span.calculatedData.deviation ? `${formatNumber(span.calculatedData.deviation * 100, 2)}%` : '-'}}</p>
              </v-col>
              <v-col class="px-1 py-0">
                <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{span.calculatedData && span.calculatedData.difference ? formatNumber(span.calculatedData.difference, 2) : '-'}}</p>
              </v-col>
            </v-row>
          </template>
          <template v-else-if="selectedOption === 'Bajantes'">
            <v-container>
              <template v-for="(span, index) in sortedSpans">
                <v-row align="baseline">
                  <p class="body-text pointer mb-0" @click="toggleOutletsSpanExpanded(index)">Tramo {{span.number}}</p>
                  <v-btn class="my-0 ml-2" text fab x-small @click="toggleOutletsSpanExpanded(index)">
                    <v-icon
                      color="rgba(0, 32, 47, 0.5)"
                    >{{outletsSpanExpanded[index] ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                  </v-btn>
                </v-row>
                <div v-show="outletsSpanExpanded[index]" class="table-scroll-container">
                  <div class="table-content">
                    <!-- Table headers -->
                    <div class="table-row table-header">
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Salida</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Tipo</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Bajante</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Regulador</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Aspersor</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Boquilla</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Caudal de boquilla / acumulado (m3/h)</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Deflector</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Peso</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 400;">Comentarios</p>
                      </div>
                    </div>
                    <!-- Table content -->
                    <div class="table-row table-data" v-for="(outlet, outletIndex) in span.outlets" :key="outletIndex">
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{outlet.number}}</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{outlet.type ? outlet.type.name : '-'}}</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{!outlet.type || outlet.type.id !== OUTLET_TYPE_OUTLET_ID ? '-' : outlet.isFlex ? 'Flexible' : 'Rígido'}}</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{outlet.regulator && outlet.regulator.regulatorType ? `${outlet.regulator.regulatorType.brand} ${outlet.regulator.regulatorType.model}` : '-'}} {{outlet.regulator && outlet.regulator.pressure ? outlet.regulator.pressure.name : ''}}</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{outlet.sprinkler && outlet.sprinkler.sprinklerType ? outlet.sprinkler.sprinklerType.id === SPRINKLER_TYPES_WITHOUT_SPRINKLER_ID ? 'No tiene' : `${outlet.sprinkler.sprinklerType.brand} ${outlet.sprinkler.sprinklerType.model}` : '-'}}</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{outlet.sprinkler && outlet.sprinkler.nozzle ? `${outlet.sprinkler.nozzle.size} ${outlet.sprinkler.nozzle.color}` : '-'}}</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{!outlet.type || outlet.type.id !== OUTLET_TYPE_OUTLET_ID ? '-' : `${outlet.flow ? formatNumber(outlet.flow) : '-'} / ${outlet.accFlow ? formatNumber(outlet.accFlow) : '-'}`}}</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{outlet.sprinkler && outlet.sprinkler.pad ? `${outlet.sprinkler.pad.brand} ${outlet.sprinkler.pad.model}` : '-'}}</p>
                      </div>
                      <div class="table-cell">
                        <p class="mb-0" style="font-size: 1rem; font-weight: 300;">{{!outlet.type || outlet.type.id !== OUTLET_TYPE_OUTLET_ID ? '-' : outlet.weight ? 'Si' : 'No'}}</p>
                      </div>
                      <div class="table-cell">
                        <v-icon @click="openCommentsDialog(outlet.observations)" style="font-size: 1.2rem; font-weight: 400; color: #00202F">mdi-comment-text-outline</v-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </v-container>
          </template>
        </div>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
import CardSatelliteImage from '../Reports/CircularGraphicsComponents/SatelliteImage.vue'
import VueApexCharts from 'vue-apexcharts'
import { isoDateToSlashes, getOutletsConfigurationAnalysis, getOutletsReportData, formatNumberHelper, isObservationsDocumentEmpty } from '../../lib/helpers'
import { AUDITS } from '../../constants/const'
import { getPivotZoom } from '../../lib/helpers'
import KeystoneDocumentRenderer from './KeystoneDocumentRenderer.vue'

export default {
  props: {
    auditData: {
      type: Object,
      required: true
    }
  },
  components: {
    CardSatelliteImage,
    apexchart: VueApexCharts,
    KeystoneDocumentRenderer
  },
  data() {
    return {
      options: [
        'Recomendaciones',
        'Bajantes a revisar',
        'Equipo',
        'Altimetría',
        'Uniformidad',
        'Bajantes'
      ],
      selectedOption: 'Recomendaciones',
      elevationReference: null,
      heatmapData: null,
      altimetryLineChart: {
        options: {
          chart: {
            height: 300,
            type: "line",
            stacked: false,
            fontFamily: "Source Sans 3, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
            toolbar: {
              show: true,
              tools: {
                download: true,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
              }
            },
            zoom: { enabled: false },
            animations: {
              enabled: false
            },
            parentHeightOffset: 0
          },
          dataLabels: { enabled: false },
          markers: { size: 0 },
          stroke: { width: 2, curve: "straight" },
          colors: [
            "#1F77B4", "#FF7F0E", "#2CA02C", "#D62728",
            "#9467BD", "#8C564B", "#E377C2", "#7F7F7F",
            "#BCBD22", "#17BECF", "#9EDAE5", "#C49C94"
          ],
          xaxis: {
            type: 'numeric',
            floating: false,
            min: 0,
            tickAmount: 8
          },
          yaxis: {
            title: {
              text: "Altimetría (m)",
              style: {
                fontWeight: 400,
                fontFamily: "Source Sans 3, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
                fontSize: "14px"
              }
            },
            decimalsInFloat: 2
          },
          tooltip: { shared: true, intersect: false },
          legend: { position: "top", horizontalAlign: "left" }
        },
        values: []
      },
      uniformityLineChart: {
        options: {
          chart: {
            type: 'line',
            height: 300,
            fontFamily: "Source Sans 3, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
            zoom: { enabled: false },
            toolbar: {
              show: true,
              tools: { download: true, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false }
            },
            animations: {
              enabled: false
            },
            parentHeightOffset: 0
          },
          stroke: { width: 3 },
          markers: { size: 3, hover: { size: 4 } },
          colors: ['#2A7BE4'],
          xaxis: {
            min: 0,
            type: 'numeric',
            tickAmount: 10
          },
          yaxis: {
            min: 0,
            tickAmount: 6,
            title: { text: 'Caudal', style: { fontWeight: 400, fontSize: '14px' } },
            labels: { formatter: v => v.toFixed(2) }
          },
          tooltip: {
            shared: false, intersect: true,
            custom: function ({ seriesIndex, dataPointIndex, w }) {
              const point = w.config.series[seriesIndex].data[dataPointIndex]
              const pointData = point.meta
              return `
                  <div style="padding:8px 10px">
                    <div><b>Tramo ${pointData.spanNumber}</b> — Bajante: ${point.x}</div>
                    <div>Marca: <b>${pointData.brand}</b></div>
                    <div>Boquilla: <b>${pointData.nozzle}</b></div>
                    <div>Caudal de boquilla: <b>${pointData.nozzleFlow}</b> m³/min</div>
                  </div>`
            }
          },
          grid: { borderColor: 'rgba(0,0,0,.15)' },
          legend: { show: false }
        },
        values: []
      },
      outletsSpanExpanded: [],
      surveyMethodDialog: false,
      commentsDialog: false,
      comments: '',
      outletsConfigurationAnalysis: {
        percentage: 0,
        total: 0,
        correct: 0,
        outletsWithoutRegulator: [],
        sprinklersWithoutNozzle: [],
        sprinklersWithoutPad: []
      },
      outletsReportData: {},
      CANNON_OUTLET_TYPE_ID: AUDITS.OUTLET_TYPES.CANNON.ID,
      OUTLET_TYPE_OUTLET_ID: AUDITS.OUTLET_TYPES.OUTLET.ID,
      OUTLET_TYPE_PLUG_ID: AUDITS.OUTLET_TYPES.PLUG.ID,
      OTHER_MOTOR_RPM_ID: AUDITS.OTHER_MOTOR_RPM_ID,
      NO_VISIBLE_MOTOR_RPM_NAME: AUDITS.NO_VISIBLE_MOTOR_RPM_ID,
      SPAN_TYPE_SPAN_ID: AUDITS.SPAN_TYPE_SPAN_ID,
      SPRINKLER_TYPES_WITHOUT_SPRINKLER_ID: AUDITS.SPRINKLER_TYPES.WITHOUT_SPRINKLER,
    }
  },
  computed: {
    sortedSpans() {
      if (!this.auditData || !this.auditData.spans) {
        return []
      }
      return this.sortSpansByNumber(this.auditData.spans)
    }
  },
  methods: {
    getPivotZoomHandler (length) {
      return getPivotZoom(length)
    },
    toggleOutletsSpanExpanded (index) {
      this.$set(this.outletsSpanExpanded, index, !this.outletsSpanExpanded[index])
    },
    openCommentsDialog (comments) {
      this.commentsDialog = true
      this.comments = comments || 'No hay observaciones'
    },
    parseDate (ISODate) {
      return isoDateToSlashes(ISODate)
    },
    formatNumber (num, decimals = 1) {
      return formatNumberHelper(num, decimals)
    },
    goToLocation (latitude, longitude) {
      window.open(`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`, '_blank')
    },
    getAltimetryLineChartValues () {
      if (!this.elevationReference || !this.elevationReference.auditAltimetryData) return []

      const step = AUDITS.ALTIMETRY.DISTANCE_TO_CENTER_DIFFERENCE
      const parsedSeries = []
      this.elevationReference.auditAltimetryData.series.forEach((series, index) => {
        parsedSeries.push({
          name: `${360 / this.elevationReference.auditAltimetryData.anglePoints * index}°`,
          data: series.map((point, i) => ({ x: i * step, y: point.elevation }))
        })
      })

      return parsedSeries
    },
    getUniformityLineChartValues () {
      const sortedSpans = this.auditData.spans.sort((a, b) => a.number - b.number)
      const values = []
      sortedSpans.forEach(span => {
        if (span && span.outlets && span.outlets.length > 0) {
          const sortedOutlets = span.outlets.sort((a, b) => a.number - b.number)
          sortedOutlets.forEach(outlet => {
            if (outlet.sprinkler && outlet.sprinkler.nozzle) {
              values.push({
                x: outlet.number,
                y: outlet.flow,
                meta: {
                  firstPoint: false,
                  spanNumber: `${span.number}`,
                  brand: outlet.sprinkler.nozzle.brand || '-',
                  nozzle: `${outlet.sprinkler.nozzle.size || '-'}`,
                  nozzleFlow: this.formatNumber(outlet.flow)
                }
              })
            }
          })
        }
      })

      return values
    },
    getUniformityLineChartAnnotations () {
      const annotations = []

      let accumulatedOutlets = 0
      this.auditData.spans.forEach((span, index) => {
        if (index === this.auditData.spans.length - 1) {
          return
        }
        accumulatedOutlets += span.outlets.length
        annotations.push({
          x: accumulatedOutlets + 0.5,
          borderColor: 'rgba(0,0,0,.55)',
          strokeDashArray: 6,
          label: {
            text: `Torre ${index + 1}`,
            style: {
                background: 'rgba(0,0,0,.1)',
                color: '#111',
                fontSize: '12px',
                fontWeight: 600
            },
            orientation: "vertical",
            offsetY: 0
          }
        })
      })

      return {
        xaxis: annotations
      }
    },
    getAltimetryLineChartAnnotations () {
      const annotations = []

      let accumulatedLength = 0
      this.sortedSpans.forEach((span, index) => { //
        if (index === this.sortedSpans.length - 1) {
          return
        }
        accumulatedLength += parseFloat(parseFloat(span.length).toFixed(2))
        annotations.push({
          x: accumulatedLength,
          borderColor: 'rgba(0,0,0,.55)',
          strokeDashArray: 6,
          label: {
            text: `Torre ${index + 1}`,
            style: {
                background: 'rgba(0,0,0,.1)',
                color: '#111',
                fontSize: '12px',
                fontWeight: 600
            },
            orientation: "vertical",
            offsetY: 0
          }
        })
      })

      return {
        xaxis: annotations
      }
    },
    sortSpansByNumber (spans) {
      return spans.sort((a, b) => a.number - b.number).map(span => ({
        ...span,
        outlets: span.outlets ? span.outlets.sort((a, b) => a.number - b.number) : []
      }))
    },
    renderAltimetryLineChart () {
      const step = AUDITS.ALTIMETRY.DISTANCE_TO_CENTER_DIFFERENCE
      const pointCount = this.elevationReference.auditAltimetryData.distanceToCenterPoints
      // Last data point is at (pointCount - 1) * step so axis ends where data ends
      const maxDistance = Math.max(step, (pointCount - 1) * step)
      const tickAmount = Math.max(1, Math.floor(maxDistance / step))
      this.$refs.altimetryLineChart.updateSeries(this.getAltimetryLineChartValues())
      const annotations = this.getAltimetryLineChartAnnotations()
      this.$refs.altimetryLineChart.updateOptions({
        annotations: annotations,
        xaxis: {
          type: 'numeric',
          min: 0,
          max: maxDistance,
          tickAmount
        }
      }, false, true)
    },
    getUniqueTyreSizes (tyres) {
      if (!tyres || !Array.isArray(tyres) || tyres.length === 0) {
        return '-'
      }

      const sizes = tyres
        .map(tyre => tyre && tyre.size ? tyre.size.name : '-')
        .filter(size => size !== '-')

      if (sizes.length === 0) {
        return '-'
      }

      // Get unique values using a simple approach
      const uniqueSizes = []
      sizes.forEach(size => {
        if (!uniqueSizes.includes(size)) {
          uniqueSizes.push(size)
        }
      })

      return uniqueSizes.join(', ')
    },
    checkObservationsDocumentEmpty () {
      return isObservationsDocumentEmpty(this.auditData)
    }
  },
  created () {
    this.outletsConfigurationAnalysis = getOutletsConfigurationAnalysis(this.auditData)
    this.outletsReportData = getOutletsReportData(this.auditData)
  },
  watch: {
    elevationReference (val) {
      if (val) {
        this.renderAltimetryLineChart()
      }
    },
    selectedOption () {
      if (this.selectedOption === 'Uniformidad') {
        this.$nextTick(() => {
          if (this.$refs.uniformityLineChart) {
            const chartValues = this.getUniformityLineChartValues()
            this.$refs.uniformityLineChart.updateSeries([{name: 'Uniformidad', data: chartValues}])

            // Calculate max x value and tickAmount for 20-unit intervals
            const maxX = chartValues.length > 0 ? Math.max(...chartValues.map(v => v.x)) : 0
            const xTickAmount = Math.ceil(maxX / 20) || 1

            const maxY = chartValues.length > 0 ? (Math.max(...chartValues.map(v => parseFloat(v.y)))) + 0.8 : 0
            const yTickAmount = Math.ceil(maxY / 0.5) || 1
            const annotations = this.getUniformityLineChartAnnotations()

            this.$refs.uniformityLineChart.updateOptions({
              annotations: annotations,
              xaxis: {
                min: 0,
                type: 'numeric',
                tickAmount: xTickAmount,
                max: Math.ceil(maxX / 20) * 20,
              },
              yaxis: {
                title: { text: 'Caudal (m³/min)', style: { fontWeight: 400, fontSize: '14px' } },
                type: 'numeric',
                min: 0,
                tickAmount: yTickAmount,
                max: Math.ceil(maxY / 0.5) * 0.5,
                labels: { formatter: v => v.toFixed(2) }
              }
            })
          }
        })
      } else if (this.selectedOption === 'Altimetría' && this.elevationReference) {
        this.$nextTick(() => {
          this.renderAltimetryLineChart()
        })
      }
    }
  }
}
</script>

<style scoped>
.field-survey-title {
  font-size: 1.38rem;
  font-weight: 600;
  color: #00202F;
}

.field-survey-subtitle {
  font-size: 1rem;
  font-weight: 400;
  color: #0099E1;
}

.Options {
  flex: 0 0 200px !important;

  .v-item--active>.v-label {
    color: #0098E1;
  }
}

.Graphic {
  position: relative;
  min-width: 50%;
  flex: 1;
}

.survey-text-body {
  color: #00202F;
  font-size: 1rem;
  font-weight: 300;
}

.survey-text-body-label {
  color: #00202F;
  font-size: 1rem;
  font-weight: 400;
}

.survey-text-label {
  color: #00202F;
  font-size: 1.25rem;
  font-weight: 300;
}

.table-scroll-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: 8px;
}

.table-content {
  min-width: 100%;
  display: table;
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  margin-bottom: 10px;
}

.table-row {
  display: table-row !important;
  height: 32px !important;
  max-height: 32px !important;
}

.table-row:last-child {
  border-bottom: none;
}

.table-cell {
  display: table-cell !important;
  min-width: 120px;
  padding: 4px 8px !important;
  vertical-align: middle !important;
  white-space: nowrap;
  height: 32px !important;
  max-height: 32px !important;
}

.table-cell:nth-child(1) { min-width: 80px; }   /* Salida */
.table-cell:nth-child(2) { min-width: 100px; }  /* Tipo */
.table-cell:nth-child(3) { min-width: 100px; }  /* Bajante */
.table-cell:nth-child(4) { min-width: 200px; }  /* Regulador */
.table-cell:nth-child(5) { min-width: 120px; }  /* Aspersor */
.table-cell:nth-child(6) { min-width: 100px; }  /* Boquilla */
.table-cell:nth-child(7) { min-width: 180px; }  /* Caudal */
.table-cell:nth-child(8) { min-width: 150px; }  /* Deflector */
.table-cell:nth-child(9) { min-width: 80px; }   /* Peso */
.table-cell:nth-child(10) { min-width: 100px; } /* Comentarios */

.table-header {
  background-color: #f5f5f5;
  font-weight: 400;
}

.table-data {
  background-color: white;
}

.table-cell p {
  margin: 0 !important;
  line-height: 1 !important;
  font-size: 0.85rem !important;
  padding: 0 !important;
  height: auto !important;
  max-height: 20px !important;
  overflow: hidden;
}
.AltimetryReference {
  height: 60px;
}
.AltimetryReference .ColorReference{
  height: 100%;
  flex: 0 0 10px !important;
  background: rgb(226,36,30);
  background: linear-gradient(180deg, rgba(226,36,30,1) 0%, rgba(204,201,22,1) 50%, rgba(108,218,25,1) 100%);
}

.AltimetryReference .ElevationValues {
  font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// FieldSurvey.vue?42a6b2d8